import React from 'react';
import { Route, Routes } from 'react-router';
import { PageIPWhitelist } from './IPWhitelist';
import { PageMFASetup } from './Setup';
import { PageMFAVerify } from './Verify';

export const PageMFA = () => {
    return (
        <Routes>
            <Route path='verify' element={<PageMFAVerify />} />
            <Route path='setup' element={<PageMFASetup />} />
            <Route path='ip-whitelist' element={<PageIPWhitelist />} />
        </Routes>
    );
};
